import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { CandidateShareUserGroup } from '@core/sharing-container-types';
import { AccessKind } from '@core/sharing-container-types';
import { AvatarComponent, DividerComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-users-grouped-by-access-kind-list-item',
  imports: [CommonModule, AvatarComponent, TranslatePipe, IconComponent, DividerComponent],
  templateUrl: './users-grouped-by-access-kind-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './users-grouped-by-access-kind-list-item.component.less',
})
export class UsersGroupedByAccessKindListItemComponent {
  protected readonly AccessKind = AccessKind;

  public group = input.required<CandidateShareUserGroup>();
  public isLast = input<boolean>();
  public isExpanded = false;

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
